import React from "react";
import classNames from "classnames";

import { Themes } from "custom-types/Themes";

type Props = {
  as?: React.ElementType;
  children?: React.ReactNode;
  className?: string;
  theme?: keyof typeof Themes;
};

const Tag: React.FC<Props> = ({
  as,
  children,
  className,
  theme,
  ...others
}) => {
  const Element = as || "span";
  const isPreferredPickupPartner = theme === Themes.preferredPickupPartner;
  const isPickup = isPreferredPickupPartner || theme === Themes.pickup;

  const classes = classNames(
    "tag",
    { "tag--preferred-pickup": isPreferredPickupPartner },
    className
  );

  return (
    <Element className={classes} {...others}>
      {isPickup && !children ? "Pickup" : children}
    </Element>
  );
};

export default Tag;
